const clientTMLStorefront = ShopifyStorefrontAPIClient.createStorefrontApiClient({
  storeDomain: 'https://tml-dev.myshopify.com',
  apiVersion: '2024-04',
  publicAccessToken: '695a8edfc38af7db88541552c17696ff',
});

window.filteredArticles = [];

window.fetchArticles = async (author, meat, keyword, sort, limit = 10, offset = 0) => {

	document.querySelector('.blog-cards__cards').classList.add('is-loading');

	// Exit if filters are empty
	if (!author && !meat && !keyword && ( !sort || sort === 'desc' ) ) {
		window.location.reload();
	}

  const query = `#graphql
    query getArticles($first: Int, $reverse: Boolean) {
		articles(
			first: $first,
			reverse: $reverse
		) {
			edges {
				node {
					id
					metafields(
						identifiers: [
							{ namespace: "custom", key: "reading_time" },
							{ namespace: "custom", key: "expert" },
						]
					) {
						reference {
							... on Metaobject {
								fields {
									key
									value
								}
							}	
						}
						key
						value
					}
					handle
					title
					image {
						url
					}
					excerpt
					content
				}
			}
		}
	}
  `;

  	const {data, errors, extensions, hasNext}  = await clientTMLStorefront.request(query, {
		variables: {
			first: 250,
			reverse: sort === 'desc' ? true : false
		}
	});

	if (errors) {
		console.error(errors);
		return;
	} else if (data) {
		// Filter the results
		const articles = data.articles.edges;
		window.filteredArticles = articles.filter( article => {
			// console.log(article);
			const fields = article.node.metafields;
			const articleFields = Object.values(article.node);
			const authorFilter = author ? fields.find( field => { 
				if (field) {
					return field.key === 'expert' && field.value === 'gid://shopify/Metaobject/' + author;
				}
			}) : true;
			const meatFilter = meat ? articleFields.find( field => {
				if (typeof field !== 'string') {
					return false;
				}
				return field.toLowerCase().search(meat.toLowerCase()) !== -1
			}) : true;
			const keywordFilter = keyword ? articleFields.find( field => {
				if (typeof field !== 'string') {
					return false;
				}
				return field.toLowerCase().search(keyword.toLowerCase()) !== -1
			}) : true;
			return authorFilter && meatFilter && keywordFilter;
		});
		// console.log(window.filteredArticles);
		// Render the filtered articles
		renderfilteredArticles(limit, offset);
	}
}

window.renderfilteredArticles = (limit, offset) => {
	const articles = window.filteredArticles;
	const grid = document.querySelector('.blog-cards__cards');
	const articlesToRender = articles.slice(offset, offset + limit);
	const noResults = document.querySelector('.blog-index .no-results');
	grid.innerHTML = '';
	noResults.classList.remove('is-visible');

	if (articlesToRender.length === 0) {
		noResults.classList.add('is-visible');
		grid.classList.remove('is-loading');
		renderPagination(articles.length, limit, offset);
		return;
	}

	articlesToRender.forEach( articleNode => {
		// Render each article card here
		let url = '/blogs/news/' + articleNode.node.handle;
		const article = articleNode.node.metafields.reduce( (acc, field) => {
			if ( field ) {
				acc[field.key] = { 
					'value': field.value,
					'reference': field.reference
				}
			}
			return acc;
		}, {});

		const expert = article.expert.reference.fields.reduce( (acc, field) => {
			acc[field.key] = { 
				'value': field.value
			}
			return acc;
		}, {});

		const readingTime = ( article.reading_time ) ? '<span class="fa fa-clock"></span> ' + article.reading_time.value + ' minuten leestijd<br/>' : '';
		const card = `
			<a class="blog-cards__card" href="${url}">
				<img src="${articleNode.node.image.url}" alt="${articleNode.node.title}">
				<div class="blog-cards__card-content">
                    <h5>Door: ${expert.name.value}</h5>
                    <h4>${articleNode.node.title}</h4>
					${readingTime}
                </div>
			</div>
		`;
		grid.innerHTML += card;
	});

	// Render the pagination
	renderPagination(articles.length, limit, offset);

	grid.classList.remove('is-loading');
};

const renderPagination = (total, limit, offset) => {
	const pagination = document.querySelector('.blog-index__pagination ul');
	const pages = Math.ceil(total / limit);
	if (pages <= 1) {
		pagination.innerHTML = '';
		return;
	}
	let buttons = '';
	for (let i = 0; i < pages; i++) {

		// Render the pagination buttons. When there are more than 5 pages, only render the current page and the next 2 pages, along with first and last page buttons.
		if (i > 2 && i < pages - 2 && i !== 0 && i !== pages - 1 && Math.abs(i - offset / limit) > 2) {
			if (i === 3) {
				buttons += `<li><span>...</span></li>`;
			}
			continue;
		}

		let btn = `<li><a onclick="renderfilteredArticles(${limit}, ${i * limit});">${i + 1}</a></li>`;

		if (i * limit === offset) {
			btn = `<li><span class="is-active">${i + 1}</a></li>`;
		}

		buttons += btn;
	}
	pagination.innerHTML = buttons;
}
